<!--  -->
<template>
  <div class="main_box">
    <div class="tinymce_box">
      <div style="margin-bottom:10px">
        <el-radio v-model="radio" label="1">客服消息</el-radio>
        <el-radio v-model="radio" label="2">模板消息</el-radio>
      </div>
      <div v-show="radio === '1'">
        <div class="tabselecr_box">
          <div class="search_box">
            <el-select v-model="obj.platform_id" placeholder="请选择平台">
              <el-option
                v-for="item in plateoption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-input v-model="obj.title" clearable style="width:200px;" placeholder="请输入标题" />
            <el-input v-model="obj.customer_message_no" clearable style="width:200px;" placeholder="请输入客服消息编号" />
            <el-select v-model="obj.msg_type" placeholder="请选择客服消息类型">
              <el-option
                v-for="item in options"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
            <el-select v-model="obj.onlyMe" placeholder="请选择">
              <el-option
                v-for="item in accountarr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchclick">搜索</el-button>
            <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
          </div>
          <div>
            <el-button type="success" icon="el-icon-plus" @click="add('1')">新增</el-button>
          </div>
        </div>

        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData.list"
          border
          tooltip-effect="dark"
          style="width: 100%;margin-top:20px"
        >
          <!-- <el-table-column
        type="selection"
        width="55"
      /> -->
          <el-table-column
            prop="customer_message_no"
            label="客服消息编号"
            align="center"
            width="230px"
          />
          <el-table-column
            prop="platform_name"
            label="所属平台"
            align="center"
          />
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          />
          <el-table-column
            prop="msg_type_str"
            label="类型"
            align="center"
          />
          <el-table-column
            align="center"
            prop="creator"
            width="180"
            label="创建人"
          />
          <el-table-column
            align="center"
            prop="created_at_text"
            width="180"
            label="创建时间"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <div class="btn-wrap-box">
                <el-button type="warning" size="small" @click="prwiedit(scope.row)">预览</el-button>
                <el-button type="primary" size="small" @click="multiplexing(scope.row,'1')">复用</el-button>
                <el-button type="success" size="small" @click.stop="editxing(scope.row)">编辑</el-button>
                <el-button type="danger" size="small" @click="deteleter(scope.row.customer_message_no)">删除</el-button>
              </div>
            </template>
          </el-table-column>

        </el-table>
        <pagination-right
          :current-page="obj.page"
          :total="tableData.total"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />
      </div>
      <div v-show="radio === '2'">
        <div class="tabselecr_box">
          <div class="sewrw_box">
            <div class="search_box">
              <el-select v-model="objs.onlyMe" placeholder="请选择" style="width:300px;">
                <el-option
                  v-for="item in accountarrtwo"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input v-model="objs.template_message_admin_no" placeholder="请输入模板编号" />
            </div>
            <div class="mobile-ht">
              <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="searchtwoclick">搜索</el-button>
              <el-button type="info" icon="el-icon-refresh-right" @click="reasttwo">重置</el-button>
            </div>
          </div>
          <div>
            <el-button type="success" icon="el-icon-plus" style="margin:10px 0px" @click="add('2')">新增</el-button>
          </div>

        </div>
        <el-table
          border
          :data="templatedata"
        >
          <!-- <el-table-column

            label="选项"
            width="100"
          >
            <template slot-scope="scope">
              <input
                v-model="scope.row.checkboxFlag"
                type="checkbox"
                @click="handleChangeSelectonewe(scope.$index, scope.row)"
              >
              {{ scope.row.$index }}
            </template>
          </el-table-column> -->
          <el-table-column
            prop="template_message_admin_no"
            label="编号"
            align="center"
            width="250"
          />
          <el-table-column
            prop="platform_name"
            label="所属平台"
            align="center"
          />
          <el-table-column
            prop="template_id_short"
            label="微信模板库ID"
            align="center"
          />
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          />
          <el-table-column
            align="center"
            prop="creator"
            width="100"
            label="创建人"
          />
          <el-table-column
            align="center"
            prop="created_at_text"
            width="180"
            label="创建时间"
          />
          <el-table-column
            label="操作"
            width="220"
            align="center"
          >
            <template slot-scope="scope">
              <div class="btn-wrap-box">
                <el-button type="warning" size="small" @click="timingpreview(scope.row,2)">预览</el-button>
                <el-button type="primary" size="small" @click="multiplexing(scope.row,'2')">复用</el-button>
                <el-button type="danger" size="small" @click="detelterw(scope.row.template_message_admin_no)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :current-page="objs.page"
          :total="templatetotalre"
          @size-change="fetchPageSizeone"
          @current-change="fetchCurrentPageone"
        />
      </div>

      <el-dialog title="新增" :visible.sync="dialogTableVisible" width="950px" append-to-body :close-on-click-modal="false" :destroy-on-close="true" @close="closedialog">
        <!--      <div class="choose_plate">
          <div class="choose_text">选择平台：</div>
          <el-select v-model="palateid" placeholder="请选择平台" @change="chooseplate">
            <el-option
              v-for="item in plateoption"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div> -->
        <el-radio v-model="type" label="1" @change="kefucahnge">客服消息</el-radio>
        <el-radio v-model="type" label="2" @change="kefucahnge">模板消息</el-radio>
        <!-- <el-radio v-model="type" label="3" @change="kefucahnge">小程序消息</el-radio> -->
        <Customerservice v-if="type === '1'" ref="sur" :plateoption="plateoption" @creatsuccessclose="creatsuccessclose" />
        <Templatemessage v-if="type === '2'" ref="surone" :plateoption="plateoption" @close="closetemplate" />
        <!-- <appletsmessage v-if="type === '3'" ref="suronee" /> -->
      </el-dialog>

      <!-- 预览标签组弹窗 -->
      <el-dialog
        title="预览"
        :visible.sync="priwdialogVisible"
        :modal-append-to-body="false"
        :append-to-body="true"
      >
        <PreviewDialog ref="timepreview" />
      </el-dialog>
    </div>

  </div>
</template>

<script>
import { customercreatlist, customermessagelist, templateadminlist, strategyPlatform, customerMessagedelete, templateAdmindelete } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Templatemessage from './components/Templatemessage'
import Customerservice from './components/Customerservice'
// import appletsmessage from './components/appletsmessage'
// appletsmessage
import PreviewDialog from '../timedPush/components/PreviewDialog'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: { Templatemessage, Customerservice, PaginationRight, PreviewDialog },
  mixins: [convertToHump],
  data() {
    return {
      radio: '1',
      tableData: [],
      obj: {
        page: 1,
        pageSize: 10,
        title: null,
        msg_type: null,
        customer_message_no: null,
        platform_id: null,
        onlyMe: 2
      },
      dialogTableVisible: false,
      priwdialogVisible: false,
      type: window.JSON.parse(window.localStorage.getItem('customerServiceTypeStorage') || '1'),
      options: [],
      loading: false,
      objs: {
        page: 1,
        pageSize: 10,
        onlyMe: 2,
        template_message_admin_no: null
      },
      accountarr: [{
        value: 1,
        label: '查看组内客服消息'
      }, {
        value: 2,
        label: '我关联的客服消息'
      }],
      accountarrtwo: [{
        value: 1,
        label: '查看组内模板消息'
      }, {
        value: 2,
        label: '我关联的模板消息'
      }],
      templatedata: [],
      templatetotalre: null,
      plateoption: [],
      palateid: null,
      storagetype: 0
    }
  },
  watch: {
    type: function(newType) {
      window.localStorage.setItem('customerServiceTypeStorage', JSON.stringify(newType))
    },
    storagetype: function(newType) {
      window.localStorage.setItem('customerServiceFatherTypeStorage', JSON.stringify(newType))
    }
  },
  created() {
    this.typelist()
    // this.menuList()
    this.gettemplateadminlist()
    this.getstrategyplatform()
  },
  mounted() {

  },
  methods: {
    // 获取策略平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.plateoption = this.convertToHump(data.data.list)
      console.log('获取策略平台', data)
    },
    menuList() {
      this.loading = true
      customercreatlist(this.obj).then(res => {
        console.log('res', res)
        this.tableData = res.data
        this.loading = false
      })
    },
    async typelist() {
      const data = await customermessagelist()
      this.options = data.data.list
      console.log('typelist data', data.data.list)
      this.options.unshift({
        key: 0,
        value: '全部'
      })
      console.log('typelist data', data.data.list)
      // this.obj.msg_type = this.options[this.options.length - 1].key
      this.obj.msg_type = 0
      this.menuList()
    },
    // 分页
    fetchPageSize(e) {
      this.obj.pageSize = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.obj.page = e
      this.menuList()
    },
    add(type) {
      this.storagetype = 8
      this.type = type
      this.dialogTableVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.sur.opens(this.dialogTableVisible, type)
      }, 100)
    },
    closedialog() {
      console.log('guanbi', this.dialogTableVisible)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.sur.close(this.dialogTableVisible)
      }, 100)
    },
    kefucahnge() {
      console.log(this.storagetype)
      // if (this.type === '2') {
      //   console.log('this.type', this.type)
      //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //     this.$refs.sur.close(false)
      //   }, 100)
      // }
      if (this.type === '1') {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.sur.opens(true)
        }, 100)
      }
    },
    rechargeclick() {
      this.obj = {
        page: 1,
        pageSize: 10,
        title: null,
        msg_type: null,
        customer_message_no: null,
        platform_id: null,
        onlyMe: 2
      }
      this.obj.msg_type = this.options[this.options.length - 1].key
      this.menuList()
    },
    searchclick() {
      this.obj.page = 1
      this.menuList()
    },
    creatsuccessclose() {
      console.log('111')
      this.dialogTableVisible = false
      this.radio = '1'
      this.menuList()
    },
    prwiedit(item) {
      console.log('item', item)
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(item, 1)
      }, 100)
    },
    async gettemplateadminlist() {
      const data = await templateadminlist(this.objs)
      this.templatedata = data.data.list
      this.templatetotalre = data.data.total
      console.log('data', data)
    },
    fetchPageSizeone(e) {
      this.objs.pageSize = e
      this.gettemplateadminlist()
    },
    fetchCurrentPageone(e) {
      this.objs.page = e
      this.gettemplateadminlist()
    },
    // 客服预览
    timingpreview(val, id) {
      console.log('val', val)
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(val, id)
      }, 100)
    },
    closetemplate() {
      this.dialogTableVisible = false
      this.radio = '2'
      this.gettemplateadminlist()
    },
    deteleter(id) {
      this.$confirm('此操作将永久删除该消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        customerMessagedelete({
          messageNo: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.menuList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
      // customerMessagedelete
    },
    detelterw(id) {
      this.$confirm('此操作将永久删除该消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        templateAdmindelete({
          messageNo: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.gettemplateadminlist()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    reasttwo() {
      this.objs.onlyMe = 2
      this.objs.page = 1
      this.objs.template_message_admin_no = null
      this.gettemplateadminlist()
    },
    searchtwoclick() {
      this.objs.page = 1
      this.gettemplateadminlist()
    },
    // 复用
    multiplexing(item, type) {
      this.storagetype = 9
      // console.log('复用', item)
      this.type = type
      this.dialogTableVisible = true
      if (this.type === '1') {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.sur.edit(item, 2)
        }, 100)
      } else {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.surone.edit(item, 2)
        }, 100)
      }
    },
    editxing(items) {
      this.type = '1'
      this.dialogTableVisible = true
      this.storagetype = 9
      this.$nextTick(() => {
        this.$refs.sur.edit(items, 3)
      })
      // setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //   this.$refs.sur.edit(item, 3)
      // }, 100)
    }
    // chooseplate(val) {
    //   console.log('val', val)
    //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
    //     this.$refs.sur.sendid(val)
    //   }, 100)
    //   if (this.$refs.surone) {
    //     this.$refs.surone.sendids(val)
    //   }
    //   // setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
    //   //   this.$refs.surone.sendids(val)
    //   // }, 100)
    // }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tinymce_box{
  /* width: 1200px;
  margin: 0 auto;
  margin-top: 50px; */
  padding: 30px;
}
.tinymceserve_box{
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.inpuwbox{
  width: 200px;
  margin-left: 20px;
}
.functional_area{
  margin-top: 20px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.choose_plate{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.choose_text{
  font-size: 14px;
  color: #606266;
}
.template_addbutton{
  text-align: right;
  width: 80%;
}
.sewrw_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.search_box{
  gap:10px;
  display: flex;
  align-items: center;
}
.main-box{
  width:100%;

}
</style>
